import {PublisherData} from './AdminDashboardByPublisher';
import ReactEcharts from 'echarts-for-react';

interface Props {
    pubDat: PublisherData[],
    style: {}
}

const DoughnutChartByPublisher = (props: Props) => {

    let requests: number = 0
    let impData: any[] = []
    let winData: any[] = []
    let labelData: any[] = []

    props.pubDat.forEach(d => {
        requests += Number.parseInt(d.request)
        winData.push({value: d.win, name: d.name})
        impData.push({value: d.impression, name: d.name})
        labelData.push(d.name)
    })

    const reqChart = {value: requests, name: 'Requests', itemStyle: {color: '#42cbf5'}}

    const option = {
        title: {
            text: 'Wins and Impressions count',
            subtext: 'by Publisher',
            // textStyle: {fontSize: 'auto'},
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: labelData
        },
        series: [
            {
                name: 'Wins',
                type: 'pie',
                radius: ['40%', '50%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{b}\nWin {c}\n({d}%)',
                },
                data: winData
            },
            {
                name: 'Impressions',
                type: 'pie',
                radius: ['12%', '38%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{b}\nImp {c}\n({d}%)',
                    position: 'inside'
                },
                data: impData
            },
            {
                name: 'Requests',
                type: 'pie',
                radius: ['0%', '10%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{c}',
                    position: 'center'
                },
                data: [reqChart]
            }
        ]
    }

    return <ReactEcharts style={{margin: '10px 10px 10px 10px', ...props.style}} option={option}/>
}

export default DoughnutChartByPublisher
